import { TFunction } from 'i18next'
import React, { PropsWithChildren } from 'react'
import AppBar from '../../../components/layout/AppBar'
import { PageWrapperProps } from '../PageWrapper'

interface WebPageLayoutProps extends PageWrapperProps {
	t: TFunction<'pages', undefined>
}

const WepPageLayout = ({
	children,
	page,
	appBarOptions,
	t,
}: PropsWithChildren<WebPageLayoutProps>) => {
	return (
		<>
			<div className='fixed top-0 left-0 right-0 z-50'>
				<AppBar
					label={page !== 'overview' ? (appBarOptions?.label ?? t(page)) : ''}
					navigationType={appBarOptions?.closeFunction || appBarOptions?.backPath ? 'back' : 'none'}
					{...appBarOptions}
					overrideBackgroundStyle={
						appBarOptions?.overrideBackgroundStyle ?? `bg-[#f5f5f5] dark:bg-background-100-dark`
					}
				/>
			</div>
			<div className='pt-[5.7rem]'>
				<div
					id={page.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()}
					className='layout-sm w-full max-w-[1200px] mx-auto'
				>
					{children}
				</div>
			</div>
		</>
	)
}

export default WepPageLayout
